/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUserChoices = /* GraphQL */ `
  query GetUserChoices($id: ID!) {
    getUserChoices(id: $id) {
      id
      response {
        challengeId
        steps
        correct
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const listUserChoicess = /* GraphQL */ `
  query ListUserChoicess(
    $filter: ModelUserChoicesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserChoicess(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        response {
          challengeId
          steps
          correct
        }
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncUserChoices = /* GraphQL */ `
  query SyncUserChoices(
    $filter: ModelUserChoicesFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUserChoices(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        response {
          challengeId
          steps
          correct
        }
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getMasterData = /* GraphQL */ `
  query GetMasterData($id: ID!) {
    getMasterData(id: $id) {
      id
      title
      description
      steps {
        sid
        explanation
        seq
        description
      }
      recommendations
      order
      hint
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const listMasterDatas = /* GraphQL */ `
  query ListMasterDatas(
    $filter: ModelMasterDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMasterDatas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        steps {
          sid
          explanation
          seq
          description
        }
        recommendations
        order
        hint
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncMasterData = /* GraphQL */ `
  query SyncMasterData(
    $filter: ModelMasterDataFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncMasterData(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        description
        steps {
          sid
          explanation
          seq
          description
        }
        recommendations
        order
        hint
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
